import TAXApi from './_taxApi';

class TAVATDeclarationAppendixAPI extends TAXApi {
  constructor() {
    super();
  }
  controllerName = 'TAVATDeclarationAppendixs';
}

export default new TAVATDeclarationAppendixAPI();
